import { createFileRoute, Outlet } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'

import { z } from 'zod'

import { MultiTenantTabs } from '@/features/air/multi-tenant/components/tabs'
import { TenantFilter } from '@/features/air/multi-tenant/components/tenant-filter'
import { prefetchMultiTenantTabs } from '@/features/air/multi-tenant/queries'
import { RouteErrorComponent } from '@/features/app-shell/route-error-component'
import { Section, SectionTitle } from '@/features/app-shell/section'

const searchSchema = z.object({
	tenants: z.array(z.string()).optional(),
	q: z.string().optional(),
})

export const Route = createFileRoute('/_dashboard/multi-tenant/_layout')({
	validateSearch: zodValidator(searchSchema),
	loaderDeps: ({ search }) => ({ tenants: search.tenants }),
	loader: ({ deps, context: { queryClient } }) =>
		prefetchMultiTenantTabs(queryClient, deps.tenants),
	head: () => ({
		meta: [{ title: 'Multi-Tenant Overview | BitLyft AIR®' }],
	}),
	component: MultiTenantLayout,
	errorComponent: RouteErrorComponent,
})

function MultiTenantLayout() {
	return (
		<Section>
			<div className="flex items-center justify-between">
				<SectionTitle>Tenants Overview</SectionTitle>
				<TenantFilter />
			</div>

			<MultiTenantTabs />

			<Outlet />
		</Section>
	)
}
